import React, { useState } from "react";
import MaintenanceService from "../../../services/maintenance";
import { simpleAlerts } from "../../../utils/alerts";
import { CODES } from "../../../utils/httpCodes";
import { Global } from "../../../utils/general";
import { pathRoute } from "../../../app/config/routesFiles";
import Swal from "sweetalert2";

const EquipmentMaintenanceHistory = ({
  data,
  newRows,
  setNewRows,
  addMaintenanceRow,
  updateNewRow,
  tiposMantenimiento,
  setTiposMantenimiento,
  handleOpenLoad,
  handleCloseLoad,
  setTitleLoad,
  url,
  selectedEquipment,
  getEquipmentMaintenance,
}) => {
  const rows = [
    ...(data?.data || []).map((row) => {
      const editingRow = newRows.find((r) => r.id === row.id_mantenimiento);
      return editingRow ? editingRow : row;
    }),
    ...newRows.filter((r) => r.isNew),
  ];

  const API_URL = Global.url;
  const [openDetalle, setOpenDetalle] = useState(false);
  const [detalleRow, setDetalleRow] = useState(null);
  const mostrarDiagnostico = selectedEquipment?.tipoEquipo?.id_tipoEquipo === 1;
  const [openFotos, setOpenFotos] = useState(false);
  const [fotos, setFotos] = useState([]);
  const esVPN = detalleRow?.tipo === 1;
  const esSeguridad = detalleRow?.tipo === 2;
  
  const saveMaintenanceRow = async (row) => {
    if (!row.fecha) {
      simpleAlerts("Seleccione fecha", "warning");
      return;
    }

    if (!row.tipo) {
      simpleAlerts("Seleccione tipo de mantenimiento", "warning");
      return;
    }
    const esVPN = row.tipo === 1;
    const payload = {
      id_mantenimiento: row.id_mantenimiento || null,
      equipo_id: selectedEquipment.id_equipo,
      tipo_mantenimiento_id: row.tipo,
      fecha: row.fecha,
      respuestas: esVPN ? {} : detalleRow?.respuestas || {},
      diagnosticos: esVPN ? [] : detalleRow?.diagnosticos || [],
      conclusion: row.conclusion || "",
      detalle_correctivo: (esVPN || esSeguridad) ? null: (row.detalle_correctivo || ""),
      costo: (esVPN || esSeguridad) ? null: (row.costo || "")
    };

    try {
      handleOpenLoad();
      setTitleLoad("Registrando mantenimiento...");

      const result = await MaintenanceService.createMaintenance(url, payload);
      if (
        result.status === CODES.CREATE_201 ||
        result.status === CODES.SUCCESS_200
      ) {
        simpleAlerts(result?.data?.message || "Guardado", "success");

        // eliminar fila local (nueva o editada)
        setNewRows((prev) =>
          prev.filter((r) => r.id !== (row.id || row.id_mantenimiento)),
        );

        handleCloseLoad();

        await getEquipmentMaintenance(selectedEquipment);
      } else {
        simpleAlerts(
          result?.response?.data?.message || "Error en el guardado",
          "error",
        );

        handleCloseLoad();
        setTitleLoad(null);
      }
    } catch (error) {
      console.log(error);
      alert("Error registrando mantenimiento");
    }
  };

  const cancelMaintenanceRow = (row) => {
    setNewRows((prev) =>
      prev.filter((r) => r.id !== (row.id || row.id_mantenimiento)),
    );
  };

  const descargarPDF = async (row) => {
    try {
      const payload = {
        mantenimiento_id: row.id_mantenimiento,
        equipo: selectedEquipment,
        detalle: row,
        laptop:mostrarDiagnostico,
      };
      handleOpenLoad();
      setTitleLoad("Descargando mantenimiento pdf...");
      const response = await MaintenanceService.generateMaintenancePDF(
        url,
        payload,
      );
      const blob = new Blob([response.data], { type: "application/pdf" });

      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = "mantenimiento.pdf";
      link.click();
      handleCloseLoad();
      setTitleLoad(null);
    } catch (error) {
      console.log(error);
      simpleAlerts("Error al generar PDF", "error");
    }
  };

  const abrirDetalle = async (row) => {
    try {
      handleOpenLoad();
      setTitleLoad("Cargando detalle...");

      const res = await MaintenanceService.getDetalle(
        url,
        row.id_mantenimiento,
      );
      const parametros = await MaintenanceService.getParametros(url);

      const respuestasMap = {};
      (res.data.respuestas || []).forEach((r) => {
        respuestasMap[r.pregunta_id] = r.respuesta;
      });

      const diagnosticosGuardados = res.data.diagnosticos || [];
      const diagnosticosMap = {};
      diagnosticosGuardados.forEach((d) => {
        diagnosticosMap[d.parametro_id] = d;
      });

      const diagnosticosFinal = parametros.data.map((p) => {
        const existente = diagnosticosMap[p.id_parametro];

        return {
          parametro_id: p.id_parametro,
          parametro: p.descripcion,
          componente: p.componente?.nombre,
          valor_inicial: existente?.valor_inicial || "",
          valor_final: existente?.valor_final || "",
        };
      });

      setNewRows((prev) => {
        const existe = prev.some((r) => r.id === row.id_mantenimiento);

        if (existe) return prev;

        return [
          ...prev,
          {
            ...row,
            id: row.id_mantenimiento,
            tipo: res.data.mantenimiento.tipo_mantenimiento_id,
            fecha: row.fecha,
            respuestas: respuestasMap,
            isNew: false,
            edit: true,
          },
        ];
      });
      const diagnosticosConDefault = diagnosticosFinal.map((d) => ({
        ...d,
        valor_inicial: d.valor_inicial || getDefaultValor(d.parametro),
        valor_final: d.valor_final || "No aplica",
      }));

      setDetalleRow({
        ...row,
        id: row.id_mantenimiento,
        tipo: res.data.mantenimiento.tipo_mantenimiento_id,
        preguntas: res.data.preguntas || [],
        respuestas: respuestasMap,
        diagnosticos: diagnosticosConDefault, // 👈 AQUI
        conclusion: res.data.mantenimiento.conclusion || "",
      });

      setOpenDetalle(true);

      handleCloseLoad();
    } catch (error) {
      console.log(error);
      simpleAlerts("Error cargando detalle", "error");
    }
  };

  const handleUploadFirmado = async (file, mantenimiento) => {
    if (!file) return;
    if (file.type !== "application/pdf") {
      simpleAlerts("No es un archivo pdf", "warning");
      return;
    }

    const formData = new FormData();
    formData.append("file", file);
    formData.append("mantenimiento_id", mantenimiento.id_mantenimiento);

    try {
      handleOpenLoad();
      setTitleLoad("Subiendo PDF firmado...");

      const res = await MaintenanceService.uploadFirmado(url, formData);

      if (res?.status === 200) {
        simpleAlerts("PDF firmado subido correctamente", "success");
        await getEquipmentMaintenance(selectedEquipment);
      } else {
        simpleAlerts("Error al subir PDF", "error");
      }

      handleCloseLoad();
    } catch (error) {
      console.log(error);
      simpleAlerts("Error al subir PDF", "error");
    }
  };

  const handleUploadFotos = async (files, mantenimiento) => {
    if (!files || files.length === 0) return;

    const formData = new FormData();

    Array.from(files).forEach((file) => {
      formData.append("files", file);
    });

    const mantenimientoId = mantenimiento.id_mantenimiento || mantenimiento.id;

    formData.append("mantenimiento_id", mantenimientoId);

    try {
      handleOpenLoad();
      setTitleLoad("Subiendo fotos...");

      const res = await MaintenanceService.uploadFotos(url, formData);

      if (res.status === 200) {
        simpleAlerts("Fotos subidas correctamente", "success");
        await getEquipmentMaintenance(selectedEquipment);
      }

      handleCloseLoad();
    } catch (error) {
      console.log(error);
      simpleAlerts("Error subiendo fotos", "error");
    }
  };

  const abrirFotos = async (mantenimiento) => {
    try {
      handleOpenLoad();
      setTitleLoad("Cargando fotos...");

      const res = await MaintenanceService.getDetalle(
        url,
        mantenimiento.id_mantenimiento,
      );

      setFotos(res.data.fotos || []);
      setOpenFotos(true);

      handleCloseLoad();
    } catch (error) {
      console.log(error);
      simpleAlerts("Error cargando fotos", "error");
    }
  };

  const eliminarFoto = async (foto) => {
    try {
      const confirm = window.confirm("¿Eliminar esta foto?");
      if (!confirm) return;
      const res = await MaintenanceService.deleteFoto(url, foto.id_foto);
      if (res.status === 200) {
        simpleAlerts("Foto eliminada", "success");
        setFotos((prev) => prev.filter((f) => f.id_foto !== foto.id_foto));
      }
    } catch (error) {
      console.log(error);
      simpleAlerts("Error eliminando foto", "error");
    }
  };

  const getDefaultValor = (parametro) => {
  switch (parametro) {
    case "Estado de salud del disco":
      return "0,0 %";

    case "Temperatura del disco":
    case "Temperatura del CPU":
      return "°C";

    case "Capacidad diseñada":
    case "Capacidad de carga completa":
      return "mWh";

    case "Nivel de desgaste":
      return "0,0 %";

    case "Resultado de prueba de RAM":
      return "0";

    default:
      return "";
  }
};

const eliminarMantenimiento = async (m) => {
  const result = await Swal.fire({
    title: "¿Eliminar mantenimiento?",
    text: "Esta acción no se puede deshacer",
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#d33",
    cancelButtonColor: "#3085d6",
    confirmButtonText: "Sí, eliminar",
    cancelButtonText: "Cancelar",
    target: document.body,

    didOpen: () => {
      const container = document.querySelector(".swal2-container");
      if (container) container.style.zIndex = "99999"; // 👈 clave
    },
  });

  if (!result.isConfirmed) return;

  try {
    handleOpenLoad();
    setTitleLoad("Eliminando mantenimiento...");
    const res = await MaintenanceService.deleteMantenimiento(
      url,
      m.id_mantenimiento,
    );
    
    if (res.status === 200) {
      handleCloseLoad();
      await Swal.fire({
        title: "Eliminado",
        text: "El mantenimiento fue eliminado correctamente",
        icon: "success",
        timer: 1500,
        showConfirmButton: false,
        target: document.body,

        didOpen: () => {
          const container = document.querySelector(".swal2-container");
          if (container) container.style.zIndex = "99999";
        },
      });

      await getEquipmentMaintenance(selectedEquipment);
    }
  } catch (error) {
    console.log(error);

    Swal.fire({
      title: "Error",
      text: "No se pudo eliminar el mantenimiento",
      icon: "error",
      target: document.body,

      didOpen: () => {
        const container = document.querySelector(".swal2-container");
        if (container) container.style.zIndex = "99999";
      },
    });
  }
};

const verPDF = async (row) => {
  try {
    handleOpenLoad();
    setTitleLoad("Cargando...");

    const payload = {
      mantenimiento_id: row.id_mantenimiento,
      equipo: selectedEquipment,
      detalle: row,
      laptop: mostrarDiagnostico,
    };

    const response = await MaintenanceService.generateMaintenancePDF(
      url,
      payload
    );

    const blob = new Blob([response.data], {
      type: "application/pdf",
    });

    const urlBlob = window.URL.createObjectURL(blob);

    window.open(urlBlob, "_blank"); // 👈 AQUÍ LA MAGIA

    handleCloseLoad();
  } catch (error) {
    console.log(error);
    handleCloseLoad();
    simpleAlerts("Error al generar PDF", "error");
  }
};

  return (
    <>
      <div className="table-responsive">
        <div className="d-flex justify-content-end mb-2">
          <button
            className="btn btn-success btn-sm"
            onClick={addMaintenanceRow}
          >
            + Agregar mantenimiento
          </button>
        </div>

        <h6 style={{ color: "black" }}>
          Historial de mantenimiento : {data?.total || 0}
        </h6>

        <table className="table table-bordered table-sm table-hover">
          <thead className="table-dark">
            <tr>
              <th style={{ width: "120px" }}>Fecha</th>
              <th style={{ width: "200px" }}>Tipo</th>
              <th style={{ width: "250px" }}>Técnico</th>
              <th style={{ width: "200px", textAlign: "center" }}>Archivos</th>
              <th style={{ width: "200px", textAlign: "center" }}>Acciones</th>
            </tr>
          </thead>

          <tbody>
            {rows.length > 0 ? (
              rows.map((m, index) => (
                <tr key={m.id || m.id_mantenimiento}>
                  <td>
                    {m.isNew || m.edit ? (
                      <input
                        type="date"
                        className="form-control form-control-sm"
                        value={m.fecha || ""}
                        onChange={(e) =>
                          updateNewRow(
                            m.id || m.id_mantenimiento,
                            "fecha",
                            e.target.value,
                          )
                        }
                      />
                    ) : (
                      m.fecha
                    )}
                  </td>

                  <td>
                    {m.isNew || m.edit ? (
                      <select
                        className="form-control form-control-sm"
                        value={m.tipo ?? ""}
                        onChange={async (e) => {
                          const tipoId = Number(e.target.value);

                          updateNewRow(m.id, "tipo", tipoId);
                          const res = await MaintenanceService.getPreguntas(
                            url,
                            tipoId,
                          );

                          const respuestasIniciales = {};
                          (res.data || []).forEach((p) => {
                            respuestasIniciales[p.id_pregunta] = "";
                          });

                          let diagnosticosIniciales = [];

                          if (
                            selectedEquipment?.tipoEquipo?.id_tipoEquipo === 1
                          ) {
                            const parametros =
                              await MaintenanceService.getParametros(url);

                            /*diagnosticosIniciales = parametros.data.map(
                              (p) => ({
                                parametro_id: p.id_parametro,
                                parametro: p.descripcion,
                                componente: p.componente?.nombre,
                                valor_inicial: "",
                                valor_final: "",
                              }),
                            );*/
                            diagnosticosIniciales = parametros.data.map(
                              (p) => ({
                                parametro_id: p.id_parametro,
                                parametro: p.descripcion,
                                componente: p.componente?.nombre,
                                valor_inicial: getDefaultValor(p.descripcion),
                                valor_final: "No aplica",
                              }),
                            );
                          }

                          setDetalleRow({
                            ...m,
                            tipo: tipoId,
                            preguntas: res.data || [],
                            respuestas: respuestasIniciales,
                            diagnosticos: diagnosticosIniciales,
                            conclusion: "",
                          });

                          setOpenDetalle(true);
                        }}
                      >
                        <option value="">Seleccione</option>
                        {tiposMantenimiento?.map((tipo) => (
                          <option key={tipo.id} value={tipo.value}>
                            {tipo.label}
                          </option>
                        ))}
                      </select>
                    ) : (
                      tiposMantenimiento?.find((t) => t.value === m.tipo)
                        ?.label || m.tipo
                    )}
                  </td>

                  <td>
                    {m.isNew ? (
                      <span style={{ color: "#888" }}>
                        Se asignará automáticamente
                      </span>
                    ) : (
                      m.tecnico
                    )}
                  </td>

                  <td style={{ textAlign: "center" }}>
                    {m.isNew || m.edit ? (
                      <span className="badge bg-warning text-dark">
                        Pendiente guardar
                      </span>
                    ) : (
                      <div className="d-flex justify-content-center gap-3">
                        <div className="d-flex gap-1 border-end pe-2">
                          <button
                            className="btn btn-outline-success btn-sm mr-1"
                            title="Descargar PDF"
                            onClick={() => descargarPDF(m)}
                          >
                            <i className="fa-solid fa-download"></i>
                          </button>
                          <button
                            className="btn btn-outline-primary btn-sm"
                            title="Ver PDF"
                            onClick={() => verPDF(m)}
                          >
                            <i className="fa-solid fa-eye"></i>
                          </button>

                          {/*m.ruta_pdf ? (
                            <>
                              <a
                                href={`${pathRoute.path}${m.ruta_pdf}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="btn btn-outline-primary btn-sm mr-1"
                                title="Ver PDF firmado"
                              >
                                <i className="fa-solid fa-file-pdf"></i>
                              </a>
                              <button
                                className="btn btn-outline-warning btn-sm"
                                title="Reemplazar PDF"
                              >
                                <label style={{ margin: 0, cursor: "pointer" }}>
                                  <i className="fa-solid fa-rotate"></i>
                                  <input
                                    type="file"
                                    accept="application/pdf"
                                    style={{ display: "none" }}
                                    onChange={(e) =>
                                      handleUploadFirmado(e.target.files[0], m)
                                    }
                                  />
                                </label>
                              </button>
                            </>
                          ) : (
                            <button className="btn btn-outline-secondary btn-sm">
                              <label style={{ margin: 0, cursor: "pointer" }}>
                                <i className="fa-solid fa-upload"></i>
                                <input
                                  type="file"
                                  accept="application/pdf"
                                  style={{ display: "none" }}
                                  onChange={(e) =>
                                    handleUploadFirmado(e.target.files[0], m)
                                  }
                                />
                              </label>
                            </button>
                          )*/}
                        </div>
                        <div className="d-flex gap-1 ps-2">
                          <button
                            className="btn btn-outline-info btn-sm mr-1"
                            title="Subir fotos"
                            disabled={!m.id_mantenimiento}
                          >
                            <label style={{ margin: 0, cursor: "pointer" }}>
                              <i className="fa-solid fa-image"></i>
                              <input
                                type="file"
                                multiple
                                accept="image/*"
                                style={{ display: "none" }}
                                onChange={(e) => {
                                  handleUploadFotos(e.target.files, m);
                                  e.target.value = null; // 👈 reset
                                }}
                              />
                            </label>
                          </button>
                          <button
                            className="btn btn-outline-dark btn-sm mr-1"
                            title="Ver fotos"
                            onClick={() => abrirFotos(m)}
                            disabled={!m.id_mantenimiento}
                          >
                            <i className="fa-solid fa-images"></i>
                          </button>
                        </div>
                      </div>
                    )}
                  </td>
                  <td style={{ textAlign: "center" }}>
                    {m.isNew || m.edit ? (
                      <div className="d-flex justify-content-center">
                        <button
                          className="btn btn-outline-success btn-sm mr-1"
                          title="Guardar mantenimiento"
                          onClick={() => saveMaintenanceRow(m)}
                        >
                          <i className="fa fa-save"></i>
                        </button>

                        <button
                          className="btn btn-outline-secondary btn-sm"
                          title="Cancelar"
                          onClick={() => cancelMaintenanceRow(m)}
                        >
                          <i className="fa fa-times"></i>
                        </button>
                      </div>
                    ) : (
                      <div className="d-flex justify-content-center">
                        <button
                          className="btn btn-outline-dark btn-sm mr-1"
                          title="Detalle de mantenimiento"
                          onClick={() => abrirDetalle(m)}
                        >
                          <i className="fa-solid fa-list-check"></i>
                        </button>

                        <button
                          className="btn btn-outline-warning btn-sm mr-1"
                          title="Editar mantenimiento"
                          onClick={() =>
                            setNewRows((prev) =>
                              prev.some((r) => r.id === m.id_mantenimiento)
                                ? prev
                                : [
                                    ...prev,
                                    {
                                      ...m,
                                      id: m.id_mantenimiento,
                                      tipo:
                                        m.tipo_mantenimiento_id ??
                                        tiposMantenimiento.find(
                                          (t) => t.label === m.tipo,
                                        )?.value,

                                      fecha: m.fecha,
                                      isNew: false,
                                      edit: true,
                                    },
                                  ],
                            )
                          }
                        >
                          <i className="fa-solid fa-pen-to-square"></i>
                        </button>

                        <button
                          className="btn btn-outline-danger btn-sm"
                          title="Eliminar mantenimiento"
                          onClick={() => eliminarMantenimiento(m)}
                        >
                          <i className="fa-solid fa-trash"></i>
                        </button>
                      </div>
                    )}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="4" style={{ textAlign: "center" }}>
                  No hay mantenimientos registrados
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {openDetalle && (
        <>
          <div
            className="modal d-block"
            style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
          >
            <div
              className="modal-dialog modal-dialog-scrollable"
              style={{ maxWidth: "100%" }}
            >
              <div className="modal-content">
                <div className="modal-header bg-primary text-white">
                  <h5 className="modal-title">Checklist de mantenimiento</h5>
                  <button
                    className="btn-close btn-close-white"
                    onClick={() => setOpenDetalle(false)}
                  ></button>
                </div>

                <div className="modal-body">
                  {!esVPN && (
                    <table className="table table-bordered">
                    <thead className="table-light">
                      <tr>
                        <th>Pregunta</th>
                        <th style={{ width: "150px" }}>Respuesta</th>
                      </tr>
                    </thead>
                    <tbody>
                      {detalleRow?.preguntas?.map((p) => (
                        <tr key={p.id_pregunta}>
                          <td>{p.descripcion}</td>

                          <td>
                            <select
                              className="form-control"
                              value={detalleRow.respuestas[p.id_pregunta] || ""}
                              onChange={(e) => {
                                setDetalleRow((prev) => ({
                                  ...prev,
                                  respuestas: {
                                    ...prev.respuestas,
                                    [p.id_pregunta]: e.target.value,
                                  },
                                }));
                              }}
                            >
                              <option value="">Seleccione</option>
                              <option value="SI">SI</option>
                              <option value="NO">NO</option>
                            </select>
                          </td>
                        </tr>
                      ))}

                      {mostrarDiagnostico && (
                        <>
                          <h6 className="mt-4" style={{ color: "black" }}>
                            Diagnóstico de mantenimiento
                          </h6>

                          <table className="table table-bordered">
                            <thead className="table-light">
                              <tr>
                                <th>Componente</th>
                                <th>Parámetro</th>
                                <th>Valor Inicial</th>
                                <th>Valor Final</th>
                              </tr>
                            </thead>

                            <tbody>
                              {detalleRow?.diagnosticos?.map((d, index) => (
                                <tr key={index}>
                                  <td>{d.componente}</td>
                                  <td>{d.parametro}</td>

                                  <td>
                                    <input
                                      type="text"
                                      className="form-control"
                                      //value={d.valor_inicial ||getDefaultValor(d.parametro)}
                                      value={d.valor_inicial ?? getDefaultValor(d.parametro)}
                                      onChange={(e) => {
                                        const newData = [
                                          ...detalleRow.diagnosticos,
                                        ];
                                        newData[index].valor_inicial =
                                          e.target.value;

                                        setDetalleRow((prev) => ({
                                          ...prev,
                                          diagnosticos: newData,
                                        }));
                                      }}
                                    />
                                  </td>

                                  <td>
                                    <input
                                      type="text"
                                      className="form-control"
                                      value={d.valor_final ?? "No aplica"}
                                      onChange={(e) => {
                                        const newData = [
                                          ...detalleRow.diagnosticos,
                                        ];
                                        newData[index].valor_final =
                                          e.target.value;

                                        setDetalleRow((prev) => ({
                                          ...prev,
                                          diagnosticos: newData,
                                        }));
                                      }}
                                    />
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </>
                      )}
                    </tbody>
                    </table>)
                  }
                  <div className="mt-3">
                    <label>
                      <b style={{ color: "black" }}>Conclusión</b>
                    </label>
                    <textarea
                      style={{ border: "1px solid #ccc" }}
                      className="form-control"
                      rows={3}
                      value={detalleRow.conclusion || ""}
                      onChange={(e) =>
                        setDetalleRow((prev) => ({
                          ...prev,
                          conclusion: e.target.value,
                        }))
                      }
                    />
                  </div>
                  {!esVPN && !esSeguridad && (
                    <div className="mt-3">
                      <label>
                        <b style={{ color: "black" }}>
                          Detalle mantenimiento correctivo solo si aplica
                        </b>
                      </label>
                      <textarea
                        style={{ border: "1px solid #ccc" }}
                        className="form-control"
                        rows={3}
                        value={detalleRow.detalle_correctivo || ""}
                        onChange={(e) =>
                          setDetalleRow((prev) => ({
                            ...prev,
                            detalle_correctivo: e.target.value,
                          }))
                        }
                      />
                    </div>
                  )}

                  {!esVPN && !esSeguridad && (
                    <div className="mt-3">
                      <label>
                        <b style={{ color: "black" }}>Costo (Opcional)</b>
                      </label>
                      <input
                        style={{ border: "1px solid #ccc" }}
                        type="number"
                        className="form-control"
                        value={detalleRow.costo || ""}
                        onChange={(e) =>
                          setDetalleRow((prev) => ({
                            ...prev,
                            costo: e.target.value,
                          }))
                        }
                      />
                    </div>
                  )}
                  
                </div>
                <div className="modal-footer">
                  <button
                    className="btn btn-secondary"
                    onClick={() => setOpenDetalle(false)}
                  >
                    Cancelar
                  </button>
                  <button
                    className="btn btn-success"
                    onClick={() => {
                      const respuestas = detalleRow?.respuestas || {};
                      const preguntas = detalleRow?.preguntas || [];
                      const diagnosticos = detalleRow?.diagnosticos || [];
                      const sinResponder = preguntas.some(
                        (p) => !respuestas[p.id_pregunta],
                      );

                      if (sinResponder) {
                        simpleAlerts(
                          "Debe responder todas las preguntas",
                          "warning",
                        );
                        return;
                      }
                      if (selectedEquipment?.tipoEquipo?.id_tipoEquipo === 1) {
                        const diagnosticosInvalidos = diagnosticos.some(
                          (d) => !d.valor_inicial || !d.valor_final,
                        );

                        if (diagnosticosInvalidos) {
                          simpleAlerts(
                            "Debe completar todos los diagnósticos (valor inicial y final)",
                            "warning",
                          );
                          return;
                        }
                      }
                      updateNewRow(detalleRow.id, "respuestas", respuestas);
                      updateNewRow(detalleRow.id, "diagnosticos", diagnosticos);
                      updateNewRow(
                        detalleRow.id,
                        "conclusion",
                        detalleRow.conclusion,
                      );
                      updateNewRow(
                        detalleRow.id,
                        "detalle_correctivo",
                        detalleRow.detalle_correctivo,
                      );
                      updateNewRow(detalleRow.id, "costo", detalleRow.costo);

                      setOpenDetalle(false);
                    }}
                  >
                    Guardar respuestas
                  </button>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
      {openFotos && (
        <>
          <div className="modal-backdrop fade show"></div>
          <div className="modal fade show d-block">
            <div className="modal-dialog modal-lg">
              <div className="modal-content">
                <div className="modal-header bg-dark text-white">
                  <h5 className="modal-title">Fotos del mantenimiento</h5>
                  <button
                    className="btn-close btn-close-white"
                    onClick={() => setOpenFotos(false)}
                  ></button>
                </div>

                <div className="modal-body">
                  {fotos.length > 0 ? (
                    <div
                      style={{ display: "flex", flexWrap: "wrap", gap: "10px" }}
                    >
                      {fotos.map((f, i) => {
                        return (
                          <div key={i} style={{ position: "relative" }}>
                            <img
                              src={`${pathRoute.path}${encodeURI(f.ruta)}`}
                              style={{
                                width: "200px",
                                height: "200px",
                                objectFit: "cover",
                                borderRadius: "8px",
                                border: "1px solid #ccc",
                              }}
                            />
                            <button
                              onClick={() => eliminarFoto(f)}
                              style={{
                                position: "absolute",
                                top: "-5px",
                                right: "-5px",
                                background: "red",
                                color: "white",
                                border: "none",
                                borderRadius: "50%",
                                width: "22px",
                                height: "22px",
                                cursor: "pointer",
                              }}
                            >
                              ×
                            </button>
                          </div>
                        );
                      })}
                    </div>
                  ) : (
                    <p>No hay fotos registradas</p>
                  )}
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default EquipmentMaintenanceHistory;
